module.exports = __webpack_public_path__ + "a0fd41ba67ef783f718fb2b53c6036ce.svg";